const SET_NEW_CONVERSATION = 'SET_NEW_CONVERSATION'
const ADD_DATASOURCE = 'ADD_DATASOURCE'
const TOGGLE_ACTIVE_DATASOURCE = 'TOGGLE_ACTIVE_DATASOURCE'
const SET_DATASOURCE_OPTIONS = 'SET_DATASOURCE_OPTIONS'
const REMOVE_DATASOURCE = 'REMOVE_DATASOURCE'
const CLEAR_DATASOURCES = 'CLEAR_DATASOURCES'
const SET_CONVERSATION_STYLE = 'SET_CONVERSATION_STYLE'
const SET_DATASOURCE_MODAL = 'SET_DATASOURCE_MODAL'

export {
  SET_NEW_CONVERSATION,
  SET_DATASOURCE_OPTIONS,
  ADD_DATASOURCE,
  TOGGLE_ACTIVE_DATASOURCE,
  REMOVE_DATASOURCE,
  CLEAR_DATASOURCES,
  SET_CONVERSATION_STYLE,
  SET_DATASOURCE_MODAL
}
